import React from "react";

import { faEyeSlash } from "@fortawesome/pro-solid-svg-icons/faEyeSlash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from "antd/es/tooltip";

import Identified from "@mapmycustomers/shared/types/base/Identified";

import BoardColumn from "../types/BoardColumn";

import styles from "./ColumnHeaderCommon.module.scss";

interface Props<DataType, ItemType extends Identified> {
  column: BoardColumn<DataType, ItemType>;
  onShow?: (column: BoardColumn<DataType, ItemType>) => void;
}

const HiddenColumn = <DataType, ItemType extends Identified>({
  column,
  onShow,
}: Props<DataType, ItemType>) => {
  return (
    <div className={styles.container}>
      <Tooltip placement="right" title={`${column.name} (${column.items.length})`}>
        <FontAwesomeIcon
          className={styles.hiddenIcon}
          icon={faEyeSlash}
          onClick={() => onShow?.(column)}
        />
      </Tooltip>
    </div>
  );
};

export default HiddenColumn;
